import AuthLayout from "@/components/layouts/auth-layout";
import { renderForgotPasswordView } from "@/components/organisms/forms/auth/render-forgot-password-view";
import { notFound } from "next/navigation";

type ForgotPasswordProps = {
  resolution: Resolution;
};

const ForgotPassword = ({ resolution }: ForgotPasswordProps) => {
  const [route] = resolution.slugs;
  const viewComponent = renderForgotPasswordView(resolution);

  if (viewComponent === null) return notFound();

  return (
    <AuthLayout route={route} locale={resolution.locale}>
      {viewComponent}
    </AuthLayout>
  );
};

export default ForgotPassword;
